import { useIntl } from 'react-intl';

import { ChartMessage } from '../../core/types/chart-message.js';
import { INCONSISTENCIES_MESSAGES } from '../messages/inconsistencies.js';
import { Inconsistency } from '../types/inconsistency.js';

export const useBuildInconsistencyMessages = (
  detectedInconsistencies: Record<Inconsistency, boolean>,
): ChartMessage[] => {
  const intl = useIntl();

  return Object.entries(detectedInconsistencies)
    .filter(([, isPresent]) => isPresent)
    .map(([key]) => ({
      severityLevel: 'warning',
      message: intl.formatMessage(
        INCONSISTENCIES_MESSAGES[key as Inconsistency],
      ),
    }));
};
